export default "__VITE_ASSET__f2386fbf__"